import { useEffect, useState } from "react";
import { useLiveQuery } from "dexie-react-hooks";
import { CloudOff, RefreshCw } from "lucide-react";
import { de } from "@ainkauf/core";
import { pendingCount } from "@/db/repository";

/** Zeigt, was noch nicht übertragen ist. Offline ist ein Zustand, kein Fehler. */
export function SyncBadge() {
  const pending = useLiveQuery(() => pendingCount(), [], 0);
  const [online, setOnline] = useState(() => navigator.onLine);

  useEffect(() => {
    const update = () => {
      setOnline(navigator.onLine);
    };
    window.addEventListener("online", update);
    window.addEventListener("offline", update);
    return () => {
      window.removeEventListener("online", update);
      window.removeEventListener("offline", update);
    };
  }, []);

  const label = !online ? de.sync.offline : pending > 0 ? de.sync.pending(pending) : de.sync.synced;
  const ruhig = online && pending === 0;

  // Ist alles übertragen, genügt ein grüner Punkt. Nur wenn etwas wartet oder
  // die Verbindung fehlt, meldet sich die Anzeige mit Zahl und Wort. Der ganze
  // Satz steht immer im Vorlesetext.
  if (ruhig) {
    return (
      <span
        role="status"
        aria-label={label}
        title={label}
        data-testid="sync-badge"
        data-online="true"
        data-pending="0"
        className="inline-flex size-9 shrink-0 items-center justify-center rounded-full bg-card shadow-[var(--shadow-card)]"
      >
        <span aria-hidden className="size-2.5 rounded-full bg-herb" />
      </span>
    );
  }

  return (
    <span
      role="status"
      aria-label={label}
      title={label}
      data-testid="sync-badge"
      data-online={online}
      data-pending={pending}
      className={`inline-flex min-h-[36px] shrink-0 items-center gap-1.5 rounded-full px-3 text-sm font-semibold ${
        online ? "bg-card text-ink-2 shadow-[var(--shadow-card)]" : "bg-honey-soft text-honey"
      }`}
    >
      {online ? <RefreshCw size={15} strokeWidth={2.25} aria-hidden /> : <CloudOff size={15} strokeWidth={2.25} aria-hidden />}
      {online ? <span className="num">{pending}</span> : <span>Offline</span>}
    </span>
  );
}
